<template>
	<v-card height="100%" class="d-flex flex-column">
		<v-card-title>
			<slot name="title">
			</slot>
		</v-card-title>
		<v-card-text class="grow">
			<slot name="text">
			</slot>
		</v-card-text>
		<v-card-actions>
			<slot name="actions">
			</slot>
		</v-card-actions>
	</v-card>
</template>

<script>
export default {
	name: "CSettingsCard",
}
</script>
